import { dockConnectionManager } from "src/helper/HubConnectionManager";
import { getDeviceConnectionGroups, getDeviceInfo, sendAsyncDjiCloudRequest } from "./deviceUtils";
import { djiCloudCustomMethod } from "src/services/common/constants";

export const sendActivateRemoteDebugging = async (deviceId) => {
  return new Promise((resolve, reject) => {
    sendAsyncDjiCloudRequest(deviceId, 'services', 'services_reply', 'debug_mode_open').then((message) => {
      console.log('🕹️ DEBUG_MODE_OPEN_RESULT', message.data);
      resolve(message.data);
    }).catch((error) => {
      console.error('🛑 DEBUG_MODE_OPEN_ERROR', error);
      reject(error);
    });
  });
}

export const sendDeactivateRemoteDebugging = async (deviceId) => {
  return new Promise((resolve, reject) => {
    sendAsyncDjiCloudRequest(deviceId, 'services', 'services_reply', 'debug_mode_close').then((message) => {
      console.log('🕹️ DEBUG_MODE_CLOSE_RESULT', message.data);
      resolve(message.data);
    }).catch((error) => {
      console.error('🛑 DEBUG_MODE_CLOSE_ERROR', error);
      reject(error);
    });
  });
}

export const sendTurnOnDrone = async (deviceId) => {
  return new Promise((resolve, reject) => {
    sendAsyncDjiCloudRequest(deviceId, 'services', 'services_reply', 'drone_open').then((message) => {
      console.log('🕹️ DRONE_OPEN_RESULT', message.data);
      resolve(message.data);
    }).catch((error) => {
      console.error('🛑 DRONE_OPEN_ERROR', error);
      reject(error);
    });
  });
}

export const sendTurnOffDrone = async (deviceId) => {
  return new Promise((resolve, reject) => {
    sendAsyncDjiCloudRequest(deviceId, 'services', 'services_reply', 'drone_close').then((message) => {
      console.log('🕹️ DRONE_CLOSE_RESULT', message.data);
      resolve(message.data);
    }).catch((error) => {
      console.error('🛑 DRONE_CLOSE_ERROR', error);
      reject(error);
    });
  });
}

export const sendSwitchBatteryStoreMode = async (deviceId, action) => {
  return new Promise((resolve, reject) => {
    sendAsyncDjiCloudRequest(deviceId, 'services', 'services_reply', 'battery_store_mode_switch', {action}).then((message) => {
      console.log('🕹️ BATTERY_STORE_MODE_SWITCH_RESULT', message.data);
      resolve(message.data);
    }).catch((error) => {
      console.error('🛑 BATTERY_STORE_MODE_SWITCH_ERROR', error);
      reject(error);
    });
  });
}

export const sendChargeOpen = async (deviceId) => {
  return new Promise((resolve, reject) => {
    sendAsyncDjiCloudRequest(deviceId, 'services', 'services_reply', 'charge_open').then((message) => {
      console.log('🕹️ CHARGE_OPEN_RESULT', message.data);
      resolve(message.data);
    }).catch((error) => {
      console.error('🛑 CHARGE_OPEN_ERROR', error)
      reject(error);
    });
  });
}

export const sendChargeClose = async (deviceId) => {
  return new Promise((resolve, reject) => {
    sendAsyncDjiCloudRequest(deviceId, 'services', 'services_reply', 'charge_close').then((message) => {
      console.log('🕹️ CHARGE_CLOSE_RESULT', message.data);
      resolve(message.data);
    }).catch((error) => {
      console.error('🛑 CHARGE_CLOSE_ERROR', error)
      reject(error);
    });
  });
}

export const sendOpenCover = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'cover_open',
    data: null,
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'cover_open' && message.bid === bid) {
          console.log('🕹️ COVER_OPEN_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendCloseCover = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'cover_close',
    data: null,
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'cover_close' && message.bid === bid) {
          console.log('🕹️ COVER_CLOSE_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendReboot = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'device_reboot',
    data: null,
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'device_reboot' && message.bid === bid) {
          console.log('🕹️ REBOOT_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendReturnHome = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'return_home',
    data: null,
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'return_home' && message.bid === bid) {
          console.log('🏠 RETURN_HOME_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendCancelReturnToHome = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'return_home_cancel',
    data: null,
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'return_home_cancel' && message.bid === bid) {
          console.log('🏠 CANCEL_RETURN_HOME_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendFlightAuthorityGrab = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'flight_authority_grab',
    data: {},
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'flight_authority_grab' && message.bid === bid) {
          console.log('👑 FLIGHT_AUTHORITY_GRAB_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendStopFlyto = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'fly_to_point_stop',
    data: null,
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'fly_to_point_stop' && message.bid === bid) {
          console.log('🕹️ FLY_TO_POINT_STOP_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendTerminateMission = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);
  const deviceInfo = getDeviceInfo(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.commands, {
    method: djiCloudCustomMethod.mission.MISSION_TERMINATE,
    gateway: deviceInfo?.serialNumber,
    data: {},
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.commands_reply],
      handler: (message) => {
        if (message.method === djiCloudCustomMethod.mission.MISSION_TERMINATE && message.bid === bid) {
          console.log('🕹️ TERMINATE_MISSION_SENT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendOpenPutter = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'putter_open',
    data: null,
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'putter_open' && message.bid === bid) {
          console.log('🕹️ PUTTER_OPEN_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendClosePutter = (deviceId) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  const { bid } = dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.services, {
    method: 'putter_close',
    data: null,
  });

  dockConnectionManager.subscribeGroupMessages([
    {
      identity: deviceId,
      name: [connectionGroups?.join?.services_reply],
      handler: (message) => {
        if (message.method === 'putter_close' && message.bid === bid) {
          console.log('🕹️ PUTTER_CLOSE_RESULT', message.data);
        }
      },
    },
  ], 'mission-tracking');
}

export const sendSetSilentMode = (deviceId, mode) => {
  const connectionGroups = getDeviceConnectionGroups(deviceId);

  dockConnectionManager.sendToDjiCloudGroup(deviceId, connectionGroups?.send?.set, {
    data: {
      silent_mode: mode
    },
  });
}
